import { useQuery } from "@tanstack/react-query";
import { getTargetareFirmeCriteriu } from "@/api/endpoints/targetareConfig";
import { queryKeys } from "@/lib/queryClient";
import type { TargetareCriteriuFirme } from "@/types/targetare";

export function useGetTargetareFirmeCriteriu(
  criteriu: TargetareCriteriuFirme | null,
  doarScop: boolean
) {
  return useQuery({
    queryKey: queryKeys.targetare.firmeCriteriu(criteriu, doarScop),
    queryFn: () =>
      getTargetareFirmeCriteriu({
        criteriu: criteriu as TargetareCriteriuFirme,
        doar_scop: doarScop,
      }),
    select: (response) => response.data,
    enabled: criteriu !== null,
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
}
